import { createContext, useContext } from 'react';

export const UnsavedChangesCtx = createContext({ markSaved: () => {}, isDirty: false, changeToken: null, confirmIfDirty: (action) => action() });
export const useUnsavedChanges = () => useContext(UnsavedChangesCtx);
